import React, {useState, useRef} from 'react'
import Add from './Add'
import Delete from './Delete'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import Camera from '../Camera'
import styled from 'styled-components'

function ReactModalAdapter({className, ...props}) {
  const contentClassName = `${className}__content`
  const overlayClassName = `${className}__overlay`
  return (
    <Modal
      className={contentClassName}
      overlayClassName={overlayClassName}
      {...props}
    />
  )
}

const Photo = ({
  add,
  onPhotoAcquired,
  field,
  hasCamera,
  selectedDevice,
  dataTestId
}) => {
  const [data, setData] = useState(null)
  const [showCamera, setShowCamera] = useState(false)
  const [isAdd, setIsAdd] = useState(add || true)

  const stream = useRef(null)

  const onAdd = evt => {	  
	    if(!evt.key || evt.key == "Enter" || evt.key == " "){ setShowCamera(true) }
  }

  const onDelete = evt => {
	if(!evt.key || evt.key == "Enter" || evt.key == " "){ 
	    setData(null)
	    setIsAdd(true)
	}
  }

  const onSaveData = data => {
    setShowCamera(false)
    setIsAdd(!data.length > 0)
    setData(data)

    // TODO: shutdown camera

    if (data.length > 0) {
      onPhotoAcquired(field, data)
    }
  }

  const onFileLoaded = evt => onSaveData(evt.target.result)
  
  const onKeyDown = evt => {
	  if(evt.key == "Enter" || evt.key == " "){
		  evt.currentTarget.click()
	  }
  }

  const onCancel = () => {
    if (stream && stream.current) {
      let tracks = stream.current.getTracks()
      tracks.forEach(track => track.stop())
    }

    setShowCamera(false)
  }

  let backgroundImage = data ? `url(${data})` : ''

  return (
    <Wrapper>
      <Container
        image={backgroundImage}
        data-testid={dataTestId || 'photo-container'}
      >
        {isAdd ? (
          <Add
            onAdd={onAdd}
            hasCamera={hasCamera}
            onFileLoaded={onFileLoaded}
            onKeyDown={onKeyDown}
            field={field}
          />
        ) : (
          <Delete onDelete={onDelete} />
        )}
      </Container>

      <StyledModal
        isOpen={showCamera}
        ariaHideApp={false}
        shouldFocusAfterRender={false}
      >
        <Camera
          onCancel={onCancel}
          onSaveData={onSaveData}
          selectedDevice={selectedDevice}
        />
      </StyledModal>
    </Wrapper>
  )
}

Photo.propTypes = {
  add: PropTypes.bool.isRequired,
  hasCamera: PropTypes.bool.isRequired
}

Photo.defaultProps = {
  add: true
}

export default Photo

const StyledModal = styled(ReactModalAdapter)`
  &__overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 40;
    background-color: black;
  }

  &__content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: calc(100vh - 80px);
    background: black;
    box-sizing: border-box;
    z-index: 100;
    display: flex;
    align-items: center;
  }
`

const Wrapper = styled.div`
  height: 100px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 11px 0;
  background: white;
`

const Container = styled.div`
  flex: 1;
  height: 94px;
  width: 94px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background-color: #f3f5fb;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: ${props => props.image};
`
